/* eslint-disable max-statements */
import { combineReducers } from 'redux';
import { ActionType, AppError } from './types';
import { CurrencyType } from '@wolffun/system-currency';
const reducers = {
  convertEventConfig: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      convertBegin: 0,
      convertEnd: 0,
      convertPool: {
        value: '0',
        token: CurrencyType.BUSD
      },
      convertMin: {
        value: '0',
        token: CurrencyType.THC
      },
      convertMax: {
        value: '0',
        token: CurrencyType.THC
      },
      convertTerms: []
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CONVERT_EVENT_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_CONVERT_EVENT_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_CONVERT_EVENT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  convertStat: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      count: 0,
      poolUsed: {
        value: '0',
        token: CurrencyType.BUSD
      },
      convertTHC: {
        value: '0',
        token: CurrencyType.THC
      },
      convertTHG: {
        value: '0',
        token: CurrencyType.THG
      }
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CONVERT_STAT_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_CONVERT_STAT_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_CONVERT_STAT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  coinConvertedEstimate: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      coinConvertedEstimate: {
        token: CurrencyType.THC,
        value: '0'
      }
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CONVERTED_ESTIMATE_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_CONVERTED_ESTIMATE_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_CONVERTED_ESTIMATE_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  convertRequirement: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR,
    data: {
      requirements: []
    }
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CONVERT_REQUIREMENT_REQUESTED:
        {
          return { ...state,
            loading: true,
            error: AppError.NO_ERROR
          };
        }

      case ActionType.FETCH_CONVERT_REQUIREMENT_SUCCESS:
        {
          const {
            data
          } = action.payload;
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data
          };
        }

      case ActionType.FETCH_CONVERT_REQUIREMENT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  convertCheckout: (state = {
    invalidated: true,
    loading: false,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.INVALIDATE_CHECKOUT_CONVERT:
        {
          return { ...state,
            invalidated: true,
            error: AppError.NO_ERROR,
            successItemId: undefined
          };
        }

      case ActionType.CHECKOUT_CONVERT_REQUESTED:
        {
          return { ...state,
            loading: true
          };
        }

      case ActionType.CHECKOUT_CONVERT_SUCCESS:
        {
          return { ...state,
            invalidated: false,
            loading: false,
            error: AppError.NO_ERROR,
            successItemId: action.payload.id
          };
        }

      case ActionType.CHECKOUT_CONVERT_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  convertHistory: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CONVERT_HISTORY_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_CONVERT_HISTORY_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_CONVERT_HISTORY_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  },
  convertHasNFTHero: (state = {
    loading: false,
    invalidated: true,
    error: AppError.NO_ERROR,
    data: false
  }, action) => {
    switch (action.type) {
      case ActionType.FETCH_CONVERT_HAS_NFT_HERO_REQUESTED:
        {
          return { ...state,
            loading: true,
            invalidated: true
          };
        }

      case ActionType.FETCH_CONVERT_HAS_NFT_HERO_SUCCESS:
        {
          return { ...state,
            loading: false,
            invalidated: false,
            error: AppError.NO_ERROR,
            data: action.payload.data
          };
        }

      case ActionType.FETCH_CONVERT_HAS_NFT_HERO_FAILURE:
        {
          return { ...state,
            loading: false,
            error: action.payload.error
          };
        }

      default:
        {
          return state;
        }
    }
  }
};
const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  // TODO: try another approach
  // if (action.type === ActionType.USER_SIGN_OUT) {
  //   return appReducer(undefined, action);
  // }
  return appReducer(state, action);
};

export { reducers };
export default rootReducer;